<template>
    <div class="CS4">
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide>
                <div class="CS4-img">
                    <img src="@/assets/CS4-1.jpg">
                </div>
                <div class="CS4-img-blur"></div>
                <div class="CS4-text">
                    <div class="CS4-text-1">CHALLENGE</div>
                    <!-- <div class="CS4-text-3">ABOUT US</div> -->
                    <div class="CS4-text-2">
                        트랜드와 서비스는 빠르게 변하고 있습니다.<br>
                        우리는 그동안의 경험과 사회의 변화를 축적하여<br>
                        사람을 위한 새로운 서비스를 만들어갑니다.
                    </div>
                </div>
            </swiper-slide>

            <swiper-slide>
                <div class="CS4-img">
                    <img src="@/assets/CS4-2.jpg">
                </div>
                <div class="CS4-img-blur"></div>
                 <div class="CS4-text">
                    <div class="CS4-text-1">CREATION</div>
                    <!-- <div class="CS4-text-3">ABOUT US</div> -->
                    <div class="CS4-text-2">
                        평범한 일상에 "IT"가 조화롭게 어우러져<br>
                       보다 멋지고 평범한듯 평범하지 않은 디지털<br>
                        세상을 그려봅니다.
                    </div>
                </div>
            </swiper-slide>

            <swiper-slide>
                <div class="CS4-img">
                    <img src="@/assets/CS4-3.jpg">
                </div>
                <div class="CS4-img-blur"></div>
                 <div class="CS4-text">
                    <div class="CS4-text-1">PASSION</div>
                    <!-- <div class="CS4-text-3">ABOUT US</div> -->
                    <div class="CS4-text-2">
                        사람이 중심이 되는 서비스를 창조하기 위해<br>
                        우리는 실패로부터 배우고 함께 공감하고 소통하며 <br>
                        고민하고 또 고민합니다.
                    </div>
                </div>
            </swiper-slide>

        </swiper>
    </div>
</template>
<script>
    export default {
        name: "CompanySlide4",
        data() {
            return {
                swiperOptions: {
                    // pagination: {
                    //     el: '.swiper-pagination',
                    // },
                    direction: 'horizontal',
                    autoplay: {
                        delay: 3000,
                    },
                    loop: true,
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .CS4 {
        width: 100%;
        height: 100%;
        background-color: #000000;
        overflow: hidden;
        position: relative;

        .CS4-img {
            height: 100%;
            overflow: hidden;
            position: relative;
            float: right;

            img {
                height: 100%;
            }
        }

        .CS4-img-blur {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
        }
        .CS4-text {
            width: 1200px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            .CS4-text-1 {
                font-size: 12vh;
                color: rgba(255,255,255,0.6);
                font-weight: 900;
                margin-bottom: 50px;
            }
            // .CS4-text-3 {
            //     font-size: 38px;
            //     font-weight: 900;
            //     color: rgba(232,192,50,0.7);
            //     margin-left: 400px;
            //     margin-bottom: 100px;
            // }
          
            .CS4-text-2 {
                font-size: 3vh;
                color: rgba(255,255,255,0.8);
                line-height: 50px;
            }
        }
    }
</style>